import * as React from 'react';

export default function AspectSquareIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
      <path d="M1 1h16v16H1V1z" fill="#F5F0FF" />
      <path
        d="M4.5 0H1a1 1 0 00-1 1v3.5h1.5v-3h3V0zM13.5 1.5V0H17a1 1 0 011 1v3.5h-1.5v-3h-3zM13.5 16.5h3v-3H18V17a1 1 0 01-1 1h-3.5v-1.5zM1.5 13.5v3h3V18H1a1 1 0 01-1-1v-3.5h1.5z"
        fill="currentColor"
      />
    </svg>
  );
}
